import _regeneratorRuntime from "@babel/runtime/regenerator";
import { call, takeEvery } from 'redux-saga/effects';
import { Socket, SOCKET_STATUS } from './socket';
import { dispatch, dispatcher, regHandlers } from '../../store';
import { bundle } from '../../helpers';
import { regSaga } from '../../saga';
import { authInterceptor } from '../../index';
regHandlers({
  SET_SOCKET_STATUS: function SET_SOCKET_STATUS(state, action) {
    return state.set('socketStatus', action.payload);
  }
});
dispatch('SET_SOCKET_STATUS', SOCKET_STATUS.CLOSED);

var createWsUri = function createWsUri() {
  if (process.env.REACT_APP_API_HOST) {
    // if there is an api host env variable (dev mode) then we can replace the
    // 'http' in that string with 'ws' to build the path
    return "".concat(process.env.REACT_APP_API_HOST.replace('http', 'ws'), "/app/topics/socket");
  } else {
    // otherwise (prod mode) we usually use paths that are root relative, but
    // the websocket path needs to include the protocol, so we determine whether
    // or not the current page is using https and get the host from the current
    // page to build the appropriate websocket uri
    var protocol = window.location.protocol !== 'http:' ? 'wss' : 'ws';
    var host = window.location.host;
    var path = "".concat(bundle.spaceLocation(), "/app/topics/socket");
    return "".concat(protocol, "://").concat(host).concat(path);
  }
}; // This handles situations where the socket goes to 'unidenfitied' which means
// the token we're using to reconnect is no longer valid.


regSaga(takeEvery('SET_SOCKET_STATUS', /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
  var payload;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _ref.payload;

          if (!(payload === SOCKET_STATUS.UNIDENTIFIED)) {
            _context.next = 10;
            break;
          }

          _context.prev = 2;
          _context.next = 5;
          return call(authInterceptor.authenticate);

        case 5:
          _context.next = 10;
          break;

        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](2);
          console.warn('There was a problem attempting to authenticate and reconnect.', _context.t0);

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 7]]);
})));
export var socket = new Socket().on('status', dispatcher('SET_SOCKET_STATUS'));
export var socketIdentify = function socketIdentify(token) {
  return new Promise(function (resolve) {
    socket.on('status', function (status) {
      if (status === SOCKET_STATUS.IDENTIFIED) {
        resolve();
      }
    });
    socket.connect(token, createWsUri());
  });
};